import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Handicap = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.98 14.804A1 1 0 0016 14h-4.133l-.429-3H16V9h-4.847l-.163-1.142A1 1 0 0010 7H9a1.003 1.003 0 00-.99 1.142l.877 6.142A2.009 2.009 0 0010.867 16h4.313l.839 4.196c.094.467.504.804.981.804h3v-2h-2.181l-.839-4.196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.51 17.5c-.739 1.476-2.25 2.5-4.01 2.5A4.505 4.505 0 014 15.5a4.503 4.503 0 012.817-4.167l-.289-2.025C3.905 10.145 2 12.604 2 15.5 2 19.084 4.916 22 8.5 22a6.497 6.497 0 005.545-3.126l-.274-1.374H12.51z"
  }));
});
Handicap.displayName = 'Handicap';
export var HandicapDimensions = {
  height: 24,
  width: 24
};